export class SearchData {
    street: string;
    number: string;
    city: string;
    postcode: string;

    constructor();
    constructor(json: any);
    constructor(json?: SearchData) {
        if (json) {
            this.street = json.street;
            this.number = json.number;
            this.city = json.city;
            this.postcode = json.postcode;
        }
    }
}



// WEBPACK FOOTER //
// ./libs/map/components/search-popup/search-data.ts